import {
  LanguageCode,
  ToolsOrganizations,
  ToolsProjects,
  Users,
} from '@prismo-io/schemas';
import { z } from 'zod';

export const ModeSchema = z.enum(['anon', 'full']);

export const ParamsSchema = z.object({
  organization: ToolsOrganizations.pick({ id: true, email: true }),
  project: ToolsProjects.pick({ id: true, name: true }),
  locale: LanguageCode.optional().default(LanguageCode.Enum.fr),
  withComments: z.boolean().optional().default(false),
  mode: ModeSchema.optional().default(ModeSchema.Enum.full),
});

export type ParamsSchemaT = z.input<typeof ParamsSchema>;
